import { BodyFlow, COLORS, TertiaryButton } from '@monthio/react-components'
import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-flow: column nowrap;
	gap: 16px;
`

export const OptionWrapper = styled.div<{ $checked: boolean }>`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	background: ${COLORS.GREY_SCALE.WHITE};
	padding: 0 16px;
	font-size: 16px;
	border-radius: 4px;
	cursor: pointer;

	${(props) =>
		props.$checked &&
		`
    background: ${COLORS.BRAND_COLORS.HIGHLIGHT_BLUE};
    outline: 1px solid ${COLORS.PRIMARY};`}
`

export const BottomTextAction = styled(TertiaryButton)<{ $clicked?: boolean }>`
	width: 100%;
	font-weight: 600;
	${(props) =>
		props.$clicked &&
		`
    background: ${COLORS.BRAND_COLORS.HIGHLIGHT_BLUE};
    outline: 1px solid ${COLORS.PRIMARY};`}
`

export const CheckboxAndTextWrapper = styled.div`
	display: flex;
	align-items: center;
`

export const BoxInputWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`

export const MissingInfoInputWrapperDiv = styled.div`
	display: flex;
	flex-direction: column;
	padding: 12px 8px 12px 12px;
	gap: 16px;
	background: ${COLORS.GREY_SCALE.WHITE};
`

export const StyledBodyFlow = styled(BodyFlow)`
	${(props) => props.theme.breakpoints.up('lg')} {
		font-size: 18px;
	}
`
